import { render, staticRenderFns } from "./MinhaLojaCategorias.vue?vue&type=template&id=2c301b03&"
import script from "./MinhaLojaCategorias.vue?vue&type=script&lang=js&"
export * from "./MinhaLojaCategorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports